/** `order_id` reaches the page as `router.query.order_id` — the shim parses it off the search string. */
import { createFileRoute } from '@tanstack/react-router'

import StateFilingsSuccessPage from '@/features/state-filings/pages/success'

export const Route = createFileRoute('/_shell/state-filings/success')({ component: StateFilingsSuccessPage })
